import { useCallback, useState } from 'react';
import StatusFormComponent from '../components/status-form.component';
import { StatusCreate, StatusUpdate } from '../types/status.types';
import { useStatusCreate } from '../hooks/use-status.hook';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  extractCreateError,
  extractValidationError,
} from '../../../../../services/extract-api-error.service';
import HeaderRow from '../../../../common/HeaderRow';
import { ValidationError } from '../../../../../types/api-response.types';
import { useTranslation } from 'react-i18next';
import { WithPermissionCheck } from '../../../../auth/WithPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const StatusCreateContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>([]);

  const { mutateAsync: createStatus, isPending } = useStatusCreate();

  const onFormSubmit = useCallback(
    async (data: StatusCreate | StatusUpdate, resetForm: () => void) => {
      // Reset validation errors on new submission
      setValidationErrors([]);

      // For create operations, we know we'll have all required fields
      const createData = data as StatusCreate;
      try {
        const response = await createStatus(createData);
        message.success(t('crud.create.success', { entity: t('statuses.title') }));
        resetForm();
        navigate(`/dashboard/status/${response.data.id}/update`);
      } catch (error: any) {
        const errorFields = extractValidationError(error);
        setValidationErrors(errorFields);
        const errorMessage = extractCreateError(
          error,
          t('crud.create.error', { entity: t('statuses.title') })
        );
        message.error(errorMessage);
      }
    },
    [createStatus, navigate, t]
  );

  return (
    <>
      <PageTitle title={t('crud.create.title', { entity: t('statuses.title') })} />
      <HeaderRow
        title={t('crud.create.title', { entity: t('statuses.title') })}
        showBackButton={true}
      />
      <div className="row mt-3">
        <StatusFormComponent
          onFormSubmit={onFormSubmit}
          isLoading={isPending}
          validationErrors={validationErrors}
        />
      </div>
    </>
  );
};

export default WithPermissionCheck(StatusCreateContainer, 'status.create');
